export default __webpack_public_path__ + "static/media/cirec1.7adfe58c.png";